import type { FC } from "react";

interface KioskIdleScreenProps {
  onCheckIn: () => void;
  onCheckOut: () => void;
}

const KioskIdleScreen: FC<KioskIdleScreenProps> = ({
  onCheckIn,
  onCheckOut,
}) => (
  <div className="relative z-10 flex flex-1 flex-col items-center justify-center px-8 py-12">
    <div className="bc-fade-up w-full max-w-3xl text-center">
      <img
        src={new URL("../assets/ths-footer-logo.svg", import.meta.url).href}
        alt="Team Housing Solutions"
        className="mx-auto w-56 sm:w-64"
      />
      <div className="mx-auto mt-10 h-px w-full max-w-md bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <div className="mt-10">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/30">
          Basecamp Lodging
        </p>
        <h1 className="mt-4 font-oswald text-6xl font-medium uppercase tracking-wide text-white sm:text-7xl">
          Welcome
        </h1>
      </div>
    </div>

    <div className="bc-fade-up bc-fade-up-2 mt-16 grid w-full max-w-3xl grid-cols-2 gap-6 sm:gap-8">
      <button
        type="button"
        onClick={onCheckIn}
        className="min-h-44 rounded-2xl bg-accentGreen px-8 py-12 font-oswald text-2xl font-medium uppercase tracking-wider text-primaryDarkBlue shadow-lg shadow-accentGreen/25 transition-all active:scale-[0.98] sm:text-3xl"
      >
        Check In
      </button>
      <button
        type="button"
        onClick={onCheckOut}
        className="min-h-44 rounded-2xl border border-white/[0.15] bg-transparent px-8 py-12 font-oswald text-2xl font-medium uppercase tracking-wider text-white transition-all hover:border-white/30 active:scale-[0.98] sm:text-3xl"
      >
        Check Out
      </button>
    </div>

    <nav
      aria-label="Kiosk legal and support"
      className="bc-fade-up bc-fade-up-3 absolute inset-x-0 bottom-6 flex justify-center gap-6 text-[11px] font-semibold uppercase tracking-[0.18em] text-white/35"
    >
      <a className="transition-colors hover:text-white/60" href="/privacy">
        Privacy Policy
      </a>
      <a
        className="transition-colors hover:text-white/60"
        href="/privacy#support"
      >
        Support
      </a>
    </nav>
  </div>
);

export default KioskIdleScreen;
